module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo7-a49ea143b72807f2a78f36ff9db97e0f.jpg";